import * as React from "react";
import { Avatar, makeStyles, Theme, createStyles } from "@material-ui/core";

interface IProps {
  firstName?: string;
  lastName?: string;
  type?: string;
}
export default function UserAvatar(props: IProps) {
  const [text, setText] = React.useState("");
  const classes = useStyles();

  React.useEffect(() => {
    let initials: string = "";
    if (props.firstName && props.firstName.length > 0) {
      initials = props.firstName.charAt(0);
    }
    if (props.lastName && props.lastName.length > 0) {
      if (initials.length > 0) initials += props.lastName.charAt(0);
      else initials = props.lastName.charAt(0);
    }
    setText(initials);
  }, [props.firstName, props.lastName]);

  function getAvatarClass() {
    switch (props.type) {
      case "table":
        return classes.avatarTable;
      case "large":
        return classes.avatarLarge;
      default:
        return classes.avatar;
    }
  }

  return <Avatar className={getAvatarClass()}>{text}</Avatar>;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    avatarTable: {
      fontSize: 14,
      height: 30,
      width: 30,
      marginRight: 10,
      background: theme.palette.secondary.main
    },
    avatar: {
      height: 40,
      width: 40,
      background: theme.palette.secondary.main
    },
    avatarLarge: {
      fontSize: 34,
      height: 100,
      width: 100,
      margin: "34px auto",
      background: theme.palette.primary.main
    }
  })
);
